import { IndicatorOrTag } from "@/modules/DashboardTemplate/models/IndicatorOrTag";
import { PropertiesToChart } from "@/modules/DashboardTemplate/models/PropertiesToChart";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Charts from "../../Charts/Charts.vue";
import ChartTypeMenu from "../../ChartTypeMenu/ChartTypeMenu.vue";
import IndicatorView from "../../IndicatorView/IndicatorView.vue";

@Component({
  name: "DashboardViewCollection",
  components: {
    IndicatorView,
    Charts,
    ChartTypeMenu
  }
})
export default class DashboardViewCollection extends Vue {
  @Prop() realDashboard?: boolean;
  @Prop({ required: true }) item!: PropertiesToChart | IndicatorOrTag;

  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;

  openFilter() {
    this.$emit("openFilter");
  }
  onChartTypeChanged(newChartType: string) {
    this.$emit("onChartTypeChanged", newChartType);
  }
}
